import { Injectable } from '@angular/core';
import {RitornoPaginazione} from "../shared/models/RitornoPaginazione";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {ApiPathsService} from "../api-paths.service";
import {Filter, Listino, ProdottoListino} from "./_Models";
import {Prodotto} from "../Progetti/Models/Prodotto";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {

  constructor(
    private http: HttpClient,
    private apiPaths: ApiPathsService,
  ) { }

  ProdottiListinoList(filter: Filter, showall:boolean){
    if(showall)
      return this.ProdottiListinoListAll(filter);
    return this.http.post<RitornoPaginazione<Listino[]>>(
      `${this.apiPaths.getBaseAPI()}/prodotti/listino/list`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  ProdottiListinoListAll(filter: Filter){
    return this.http.post<RitornoPaginazione<Listino[]>>(
      `${this.apiPaths.getBaseAPI()}/prodotti/listino/listAll`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  ProdottiListinoGet(listino){
    return this.http.post<RitornoPaginazione<Listino>>(
      `${this.apiPaths.getBaseAPI()}/prodotti/listino/get`,
      JSON.stringify(listino),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  ProdottiListinoProdotti(filter: Filter){
    return this.http.post<RitornoPaginazione<Prodotto[]>>(
      `${this.apiPaths.getBaseAPI()}/prodotti/listino/prodotti/list`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  ProdottiListinoAdd(value: Listino): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoUpdate(value: Listino): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoDelete(value: Listino): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/delete `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoRestore(value: Listino): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/restore `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoProdottiAdd(value: ProdottoListino){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/prodotti/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoProdottiUpdate(value: ProdottoListino){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/prodotti/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoProdottiDelete(value: ProdottoListino){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/prodotti/delete `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoProdottiRestore(value: ProdottoListino){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/listino/prodotti/restore `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }

}
